import { Component, OnInit } from '@angular/core';
import { ViewService } from '@services/view.service';
import { GlobalService } from '@common/global';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { CommonPipe } from '@pipes/common.pipe';
import { MailService } from '@services/mail.service';
import * as _ from 'lodash';
import { NgxSmartModalService } from 'ngx-smart-modal';
import { VgApiService } from '@videogular/ngx-videogular/core';
import { fadeInLeftOnEnterAnimation } from 'angular-animations';
@Component({
  selector: 'app-vplay-list',
  providers: [CommonPipe],
  templateUrl: './vplay-list.component.html',
  styleUrls: ['./vplay-list.component.sass'],
  animations: [
    fadeInLeftOnEnterAnimation({ anchor: 'fadeInLeft' })
  ]
})
export class VplayListComponent implements OnInit {
  application = "audio";
  component = '';
  compose_response: any = [];
  is_owner = false;
  rate = 0;
  toggler = true;
  currentIndex = 0;
  audio_url = {};
  params: any = [];
  action_class: any = {};
  pathToMedia: any = {};
  id = "";
  response: any = [];
  images: any = [];
  report_param: any = [];
  audio_loading=false;
  isLogin = false;
  btn_process = false;
  rate_readonly = false;
  page_load = true;
  //image_paths: any = [];
  api: VgApiService;
  audio_source: any = [];
  playlist_response = [];
  constructor(public ngxSmartModalService: NgxSmartModalService, private _mail: MailService, private router: Router, private _commonPipe: CommonPipe, private route: ActivatedRoute, private _viewService: ViewService, private _global: GlobalService) {

    
    this.router.routeReuseStrategy.shouldReuseRoute = function () {
      return false;
    }

    if (this._global.isAuthenticated()) {
      this.isLogin = true;
    }

    let pa=this._global.getAppViewParam(this.route.snapshot.url[1].path);
    this.component=pa.c;
    this.id=pa.id;
      let p = {
        'component': this.component,
        'application': 'playList',
        'id': this.id
      };
      this._viewService.application(p).subscribe(
        data => {
          if (!_.isEmpty(this._global.getVal(data, 'response', ''))) {
            this.page_load = false;
            this.playlist_response = this._global.getVal(data, 'response', '');
            this.is_owner = this._global.isOwner(this._global.getVal(this.playlist_response, 'createdBy', ''));
            this.pathToMedia = this._global.getVal(this.playlist_response, 'pathToMedia', {});
          //  this.image_paths.push(this.pathToMedia);
            let first = true;
            Object.entries(this.pathToMedia).forEach(([key, value]) => {
              this.audio_source.push(value);
              if (first) {
                this.audio_url = value;
                this.loadMedia(value['uid']);
                first = false;
              }

            });
            Object.entries(this.playlist_response['audio']).forEach(([key, value]) => {
              value = this._global.asJsonObject(value);
              value['uid']=value['id'];
              let r = {
                mediaType: "audio",
                uid: key,
                id:key,
                name: value['name']
              }
              if(first){
                this.audio_url = value;
                this.loadMedia(key);
                first = false;
              }
              this.audio_source.push(r);
            });
            this._global.addMetaInfo(this.response, 'view','name');
            this.report_param = {
              id: this.response.id,
              name: this.response.name
            };

          }else{
            this.router.navigate(['']);
          }
        },
        error => {
          console.log("error", JSON.stringify(error));
          this.router.navigate(['']);
        });
  }
  ngOnInit() {

  }
  edit() {
    this.router.navigate(['/my/audio'], { queryParams: { 'playlistid': this.id } });
  }
  audioEdit(){
    this.router.navigate(['/edit/'+this.application], { queryParams: { a:this.application,'id': this.response['id'] } });
  }
  playListEdit(){
    this.router.navigate(['/edit/playList'], { queryParams: { a:'playList','id': this.id } });
  }
  loadMedia(id) {
    this.audio_loading=false;
    this.response={};
    let p = {
      'component': this.component,
      'application': this.application,
      'id': id
    };
    this._viewService.application(p).subscribe(
      data => {
        if (!_.isEmpty(this._global.getVal(data, 'response', ''))) {
          this.audio_loading=true;
          this.response = this._global.getVal(data, 'response', '');
          this._global.addMetaInfo(this.response, 'view','name');
          this.report_param = {
            id: this.response.id,
            name: this.response.name
          };
        }
      },
      error => {
        console.log("error", JSON.stringify(error));
      });
  }
  report() {

    this.ngxSmartModalService.getModal('popupOne').open()
    let p = {
      component: 'm',
      application: 'mail'
    };
    this._mail.compose(p).subscribe(
      data => {
        if (!_.isEmpty(this._global.getVal(data, 'response', ''))) {
          this.compose_response = this._global.getVal(data, 'response', '');
        }
      },
      error => {
        console.log("error", JSON.stringify(error));
      });
  }
  returnZero() {
    return 0
  }

  gotoAudio(obj, index) {
    this.currentIndex = index;
    this.audio_url = obj;
    this.loadMedia(obj['uid']);
  }

  onPlayerReady(api: VgApiService) {
    this.api = api;

    this.api.getDefaultMedia().subscriptions.loadedMetadata.subscribe(this.playAudio.bind(this));
    this.api.getDefaultMedia().subscriptions.ended.subscribe(this.nextAudio.bind(this));
  }
 
  nextAudio() {
    this.currentIndex++;
    if (this.currentIndex === this.audio_source.length) {
      this.currentIndex = 0;
    }
    this.audio_url = this.audio_source[this.currentIndex];
    this.loadMedia(this.audio_url['uid']);
    this.api.play();
  }

  playAudio() {
    this.api.play();
  
  }

}
